import { Box, Button } from "@modernatx/ui-kit-react-v2";
import React from "react";

import { SearchLocationMarker } from "../FinderMap";
import { useMapContext } from "../googleMaps/GoogleMapsProvider";
import useSearchThisArea from "../hooks/useSearchThisArea";

export const SearchThisAreaButton = ({ onClick, text }: { onClick: () => void; text: string }) => {
  const { hasPanned, setHasPanned } = useMapContext();

  const handleClick = () => {
    onClick();
    setHasPanned(false);
  };

  return (
    <Box
      id="search-this-area"
      sx={{
        borderRadius: "radius-2",
        width: "fit-content",
        height: "fit-content",
        boxShadow: "shadow-200",
        transition: "transition-ease-out-medium",
        opacity: hasPanned ? 1 : 0,
        visibility: hasPanned ? "visible" : "hidden",
        pointerEvents: "auto"
      }}
    >
      <Button
        data-track="search-this-area"
        icon="magnifying-glass"
        iconPosition="start"
        variant="outline"
        size="large"
        aria-label={text}
        onClick={handleClick}
      >
        {text}
      </Button>
    </Box>
  );
};

// FinderList renders the list of locations, taking into consideration the
// selected view and size breakpoints
export const FinderListViewWrapper = ({
  children,
  isMobileView,
  selectedView,
  searchThisAreaText
}: {
  children: React.ReactNode;
  isMobileView: boolean;
  selectedView: "list" | "map";
  searchThisAreaText: string;
}) => {
  const { hasPanned } = useMapContext();
  const searchLocationMarkerRef = React.useRef<HTMLDivElement | null>(null);

  const { runSearchThisArea } = useSearchThisArea(searchLocationMarkerRef.current, isMobileView);

  if (isMobileView) {
    return (
      <>
        {selectedView === "map" && (
          <Box
            id="view-column"
            sx={{
              position: "absolute",
              width: "100%",
              justifyContent: "center",
              display: "flex",
              pointerEvents: "none",
              mt: 4
            }}
          >
            <SearchThisAreaButton text={searchThisAreaText} onClick={runSearchThisArea} />
          </Box>
        )}
        {children}
      </>
    );
  }

  return (
    <>
      <Box
        sx={{
          position: "absolute",
          pointerEvents: "none",
          width: "100%",
          height: "100%",
          display: "flex"
        }}
      >
        <Box
          id="view-column"
          sx={{
            width: () => "350px",
            height: "100%",
            marginLeft: 8,
            paddingTop: 8,
            paddingBottom: 8,
            display: "flex",
            flexDirection: "column",
            minHeight: 0
          }}
        >
          {children}
        </Box>
      </Box>

      <Box
        sx={{
          position: "absolute",
          display: "flex",
          pointerEvents: "none",
          width: "100%",
          justifyContent: "center",
          mt: 4,
          paddingLeft: 104
        }}
      >
        <SearchThisAreaButton text={searchThisAreaText} onClick={runSearchThisArea} />
      </Box>
      <Box
        sx={{
          position: "absolute",
          width: "100%",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          transition: "transition-ease-out-medium",
          opacity: hasPanned ? 1 : 0,
          visibility: hasPanned ? "visible" : "hidden",
          pointerEvents: "none",
          paddingLeft: 104
        }}
      >
        <div ref={searchLocationMarkerRef}>
          <SearchLocationMarker />
        </div>
      </Box>
    </>
  );
};
